import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {FusePageSimple, FuseAnimate} from '@fuse';

import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Actions from 'store/actions';
import { FormControlLabel, Checkbox, Paper, Button, Chip, Divider, Typography, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core';
import HomeIcon from '@material-ui/icons/Home';

const styles = theme => ({
    layoutRoot: {},
    pagingPeringkat: {
        textAlign: 'right'
    },
    tabSelected: {
        borderBottom: '5px solid #4EBAE7',
        background: '#ECEFF1',
        color: 'white'
    },
});

class PaktaIntegritas extends Component {
    state = {
        error:0,
        routeParams:{
            foo: 'bar',
            sekolah_id: JSON.parse( localStorage.getItem('user') ).sekolah_id,
            tahun: localStorage.getItem('tahun'),
            token: localStorage.getItem('jwt_token'),
            data: {
                sekolah_id: JSON.parse( localStorage.getItem('user') ).sekolah_id,
                tahun_ajaran_id: localStorage.getItem('tahun'),
                pengguna_id: JSON.parse( localStorage.getItem('user') ).pengguna_id
            },
            jenis_timeline_id: 5
        },
        checkboxSetujuValue: false,
        buttonDisabled: true,
        buttonDisabledBatal: true,
        kunci_pakta: false,
        wholeTime: null,
        checkDisabled: false,
        dialogBlocking: false,
        dialogTitle: (<span>Mengecek kemajuan pengisian...</span>),
        dialogText: (<span>Mohon tunggu beberapa saat ...</span>),
        disableDialogButton: true,
        teksButton: 'Konfirmasi Pakta Integritas Sekolah',
        maxTimeline: 0
    }

    goTolink = (url) => {
        this.props.history.push(url);
    };

    componentDidMount = () => {
        this.props.setJudul('Pakta Integritas Sekolah');

        this.props.getSekolah(this.state.routeParams).then((result)=>{
            // console.log(this.props.sekolah);
        });

        let bulan = [
            'Januari',
            'Februari',
            'Maret',
            'April',
            'Mei',
            'Juni',
            'Juli',
            'Agustus',
            'September',
            'Oktober',
            'November',
            'Desember'
        ];

        let today = new Date();
        let month = bulan[today.getMonth()];
        let day = today.getDate();
        let year = today.getFullYear();
        let jam = today.getHours();
        let menit = today.getMinutes();
        let wholeTime = day + ' ' + month + ' ' + year + ', pukul ' + jam + ':' + menit; 

        this.setState({
            ...this.state,
            wholeTime: wholeTime
        });

        this.props.getTimeline(this.state.routeParams).then((result)=>{
            let maxTimeline = 0;
            // let tanggal = new Date();

            const array = this.props.timeline;
            for (let index = 0; index < array.length; index++) {
                const element = array[index];

                if(element.tanggal !== null){
                    maxTimeline = element.jenis_timeline_id;
                    // tanggal = new Date(element.tanggal);
                }
            }

            // this.props.timeline.map((option)=>{
                // if(Number(option.jenis_timeline_id) === 4 && option.tanggal !== null){
                //     this.setState({
                //         ...this.state,
                //         checkDisabled: false
                //     });
                // }else{
                //     this.setState({
                //         ...this.state,
                //         checkDisabled: true,
                //         dialogTitle: (<span>Apakah Pengawas Anda telah melakukan pakta integritas?</span>),
                //         dialogText: (<span>Sebelum membuka menu ini, silakan pastikan bahwa Pengawas Sekolah Anda telah melakukan pakta integritas rapor mutu</span>),
                //         disableDialogButton: false
                //     })
                // }

                // if(Number(option.jenis_timeline_id) === 2 && option.tanggal !== null){
                //     this.setState({
                //         ...this.state,
                //         checkDisabled: false
                //     });
                // }else{
                //     this.setState({
                //         ...this.state,
                //         checkDisabled: true,
                //         // dialogTitle: (<span>Apakah Pengawas Anda telah melakukan pakta integritas?</span>),
                //         // dialogText: (<span>Sebelum membuka menu ini, silakan pastikan bahwa Pengawas Sekolah Anda telah melakukan pakta integritas rapor mutu</span>),
                //         disableDialogButton: false,
                //         dialogBlocking: false
                //     })
                // }

                // if(Number(option.jenis_timeline_id) === 5 && option.tanggal !== null){
                //     this.setState({
                //         ...this.state,
                //         kunci_pakta: true,
                //         wholeTime: option.tanggal,
                //         checkDisabled: true,
                //         checkboxSetujuValue: true
                //     })
                // }
            //     if(option.tanggal !== null){
            //         maxTimeline = option.jenis_timeline_id;
            //         tanggal = new Date(option.tanggal);
            //     }

            // });

            // console.log(maxTimeline);

            if(Number(maxTimeline) === 2){
                // alert(maxTimeline+"!!");
                this.setState({
                    ...this.state,
                    // checkDisabled: false,
                    maxTimeline: maxTimeline
                });
            } else if(Number(maxTimeline) === 3){
                // alert(maxTimeline+"!!");
                this.setState({
                    ...this.state,
                    checkDisabled: false,
                    maxTimeline: maxTimeline
                });
            } else if(Number(maxTimeline) === 4){
                // alert(maxTimeline+"!!");
                this.setState({
                    ...this.state,
                    checkDisabled: false,
                    maxTimeline: maxTimeline
                });
            } else if(Number(maxTimeline) === 5){
                // alert(maxTimeline+"!!");
                this.setState({
                    ...this.state,
                    checkDisabled: true,
                    kunci_pakta: true,
                    teksButton: 'Anda telah konfirmasi pakta integritas',
                    maxTimeline: maxTimeline,
                    buttonDisabledBatal: false
                });
            } else{

                if(Number(maxTimeline) === 1){
                    // alert(maxTimeline);
                    this.setState({
                        ...this.state,
                        checkDisabled: true,
                        kunci_pakta: false,
                        teksButton: 'Silakan hitung rapor mutu terlebih dahulu',
                        maxTimeline: maxTimeline
                        // wholeTime: wholeTime
                    });
                }else{

                    if(Number(maxTimeline) >= 5){
                        // alert(maxTimeline+"!!!!");
                        // let today = tanggal;
                        // let month = bulan[today.getMonth()];
                        // let day = today.getDate();
                        // let year = today.getFullYear();
                        // let jam = today.getHours();
                        // let menit = today.getMinutes();
                        // let wholeTime = day + ' ' + month + ' ' + year + ', pukul ' + jam + ':' + menit; 
    
                        this.setState({
                            ...this.state,
                            checkDisabled: true,
                            kunci_pakta: true,
                            teksButton: 'Anda telah konfirmasi pakta integritas',
                            maxTimeline: maxTimeline
                            // wholeTime: wholeTime
                        });
                    }else{
                        // alert(maxTimeline+"!!!!!!");
                        this.setState({
                            ...this.state,
                            checkDisabled: true,
                            kunci_pakta: false,
                            maxTimeline: maxTimeline
                        });
                    }

                }


            }
        });
    }

    setValueCheckbox = (e, checked) => {
        // console.log(checked);
        if(checked === true){
            this.setState({
                ...this.state,
                buttonDisabled: false,
                checkboxSetujuValue: !this.state.checkboxSetujuValue
            });
        }else{
            this.setState({
                ...this.state,
                buttonDisabled: true,
                checkboxSetujuValue: !this.state.checkboxSetujuValue
            });
        }
        // // console.log(this.state.checkboxSetujuValue);
        // this.setState({
        //     ...this.state,
        //     checkboxSetujuValue: !this.state.checkboxSetujuValue
        // }),()=>{
        //     console.log(this.state.checkboxSetujuValue);
        //     // if(this.state.checkboxSetujuValue === true){
        //     //     this.setState({
        //     //         ...this.state,
        //     //         buttonDisabled: false
        //     //     });
        //     // }else{
        //     //     this.setState({
        //     //         ...this.state,
        //     //         buttonDisabled: true
        //     //     });
        //     // }
        // };
    }

    simpanFaktaIntegritas = (e) => {
        // alert('tes');
        this.props.setLoadingBesar(true);

        this.props.catatTimeline(this.state.routeParams).then((result)=>{
            this.props.getTimeline(this.state.routeParams).then((result)=>{
                this.props.setLoadingBesar(false);

                const array = this.props.timeline;
                for (let index = 0; index < array.length; index++) {
                    const option = array[index];

                // this.props.timeline.map((option)=>{
                    if(Number(option.jenis_timeline_id) === 5 && option.tanggal !== null){
                        this.setState({
                            ...this.state,
                            kunci_pakta: true,
                            wholeTime: option.tanggal,
                            checkDisabled: true,
                            checkboxSetujuValue: true,
                            buttonDisabled: true,
                            buttonDisabledBatal: false
                        },()=>{
                            this.props.getSekolah(this.state.routeParams).then((result)=>{
                                                                
                                this.setState({
                                    ...this.state,
                                    routeParams: {
                                        ...this.state.routeParams,
                                        keterangan: 'Kepala Sekolah ' + this.props.sekolah.nama + ' mengonfirmasi pakta integritas sekolah untuk ' + this.props.sekolah.nama,
                                        tautan: '/PaktaIntegritas',
                                        tujuan_notifikasi_id: 1,
                                        jenis_notifikasi_id: 5
                                    }
                                },()=>{
                                    this.props.setNotifikasi(this.state.routeParams).then((result)=>{
                                        this.props.getNotifikasi(this.state.routeParams);
                                    });
                                });
                                
                            });
                            // this.props.setNotifikasi(this.state.routeParams);
                        })
                    }
                // })
                }
            });
            
        });
    }

    simpanFaktaIntegritasBatal = (e) => {
        // alert('tes');
        this.props.setLoadingBesar(true);

        this.props.catatTimelineBatal(this.state.routeParams).then((result)=>{
            this.props.getTimeline(this.state.routeParams).then((result)=>{
                this.props.setLoadingBesar(false);

                this.setState({
                    ...this.state,
                    kunci_pakta: false,
                    // wholeTime: option.tanggal,
                    checkDisabled: false,
                    checkboxSetujuValue: false,
                    buttonDisabled: false,
                    buttonDisabledBatal: true
                },()=>{
                    // this.props.getSekolah(this.state.routeParams).then((result)=>{
                                                        
                    //     this.setState({
                    //         ...this.state,
                    //         routeParams: {
                    //             ...this.state.routeParams,
                    //             keterangan: 'Kepala Sekolah ' + this.props.sekolah.nama + ' mengonfirmasi pakta integritas sekolah untuk ' + this.props.sekolah.nama,
                    //             tautan: '/PaktaIntegritas',
                    //             tujuan_notifikasi_id: 1,
                    //             jenis_notifikasi_id: 5
                    //         }
                    //     },()=>{
                    //         this.props.setNotifikasi(this.state.routeParams).then((result)=>{
                    //             this.props.getNotifikasi(this.state.routeParams);
                    //         });
                    //     });
                        
                    // });
                    // this.props.setNotifikasi(this.state.routeParams);
                });

                // this.props.timeline.map((option)=>{
                //     if(Number(option.jenis_timeline_id) === 5 && option.tanggal !== null){
                //         this.setState({
                //             ...this.state,
                //             kunci_pakta: true,
                //             wholeTime: option.tanggal,
                //             checkDisabled: true,
                //             checkboxSetujuValue: true,
                //             buttonDisabled: true
                //         },()=>{
                //             this.props.getSekolah(this.state.routeParams).then((result)=>{
                                                                
                //                 this.setState({
                //                     ...this.state,
                //                     routeParams: {
                //                         ...this.state.routeParams,
                //                         keterangan: 'Kepala Sekolah ' + this.props.sekolah.nama + ' mengonfirmasi pakta integritas sekolah untuk ' + this.props.sekolah.nama,
                //                         tautan: '/PaktaIntegritas',
                //                         tujuan_notifikasi_id: 1,
                //                         jenis_notifikasi_id: 5
                //                     }
                //                 },()=>{
                //                     this.props.setNotifikasi(this.state.routeParams).then((result)=>{
                //                         this.props.getNotifikasi(this.state.routeParams);
                //                     });
                //                 });
                                
                //             });
                //             // this.props.setNotifikasi(this.state.routeParams);
                //         })
                //     }
                // })
            });
        });

    }

    handleCloseDialogBlocking = () => {
        this.setState({
            ...this.state,
            dialogBlocking: false,
            hideRapor: false
        })
    }

    handleCloseHitungRaporMutu = () => {
        this.props.history.push("/HasilVerval");
    }

    handleCloseBeranda = () => {
        this.props.history.push("/Beranda");
    }

    render()
    {
        const {classes} = this.props;
        
        return (
            <FusePageSimple
                classes={{
                    root: classes.layoutRoot
                }}
                content={
                    <FuseAnimate
                        animation="transition.slideRightBigIn"
                        duration={400}
                        delay={400}
                    >
                        <div style={{width: '100%', padding: 10}} className="konten-utama">
                            {/* <GhostList/>
                            <GhostList/>
                            <GhostList/>
                            <GhostList/> */}
                            <Dialog
                                open={this.state.dialogBlocking}
                                onClose={this.handleCloseDialogBlocking}
                                aria-labelledby="alert-rapor-mutu-belum"
                                aria-describedby="alert-rapor-mutu-belum"
                            >
                                <DialogTitle id="alert-rapor-mutu-belum-title">{this.state.dialogTitle}</DialogTitle>
                                <DialogContent>
                                <DialogContentText id="alert-rapor-mutu-belum-description">
                                    {this.state.dialogText}
                                </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                <Button onClick={this.handleCloseHitungRaporMutu} color="primary" disabled={this.state.disableDialogButton}>
                                    Verval Rapor Mutu
                                </Button>
                                <Button onClick={this.handleCloseBeranda} color="primary" autoFocus disabled={this.state.disableDialogButton}>
                                    Beranda
                                </Button>
                                </DialogActions>
                            </Dialog>
                            <div style={{minHeight: 10, width: '100%', background: '#4EBBE8', overflow: 'auto', maxHeight: '42px', display: 'inline-flex'}}>
                                <Chip
                                    icon={<HomeIcon/>}
                                    label=""
                                    className={this.props.classes.chip}
                                    color="primary"
                                    style={{justifyContent: 'start', marginLeft: 0, padding: 5, borderRadius: 0, borderRight: '1px solid #ccc', paddingLeft: '0px', paddingRight: '0px'}}
                                    onClick={()=>{this.goTolink('/Beranda')}}
                                />
                                <Chip
                                    label={"> Pakta Integritas"}
                                    className={this.props.classes.chip}
                                    color="secondary"
                                    // onClick={()=>{this.goTolink('/ManajemenPengguna')}}
                                    style={{justifyContent: 'start', marginRight: 0, padding: 5, borderRadius: 0, paddingLeft: 0, paddingRight: 0, fontSize: 12}}
                                />
                            </div>
                            
                            <Paper className="p-16 m-8" style={{marginBottom:'10px'}}>
                                <Typography variant="title">
                                    PAKTA INTEGRITAS SEKOLAH
                                </Typography>
                                <Typography variant="caption">
                                    Tanggal {this.state.maxTimeline >= 5 ? (this.props.timeline ? this.props.timeline[2].tanggal : this.state.wholeTime ) : this.state.wholeTime}
                                </Typography>
                                <br/>
                                <Typography variant="body1">
                                    Dengan ini Saya sebagai Kepala Sekolah {this.props.sekolah.nama} menyatakan bahwa data yang diisi pada kuesioner pemetaan PMP tahun pendataan {localStorage.getItem('tahun')} telah diperiksa kebenarannya dan telah sesuai dengan fakta yang ada di lapangan.
                                </Typography>
                                <br/>
                                <Typography variant="body1">
                                    Saya sepenuhnya siap bertanggung jawab apabila di kemudian hari ditemukan ketidaksesuaian antara data yang diisi di kuesioner pemetaan PMP dengan fakta yang ada di lapangan, dan Saya siap menerima sanksi moral, sanksi administrasi, dan sanksi hukum sesuai dengan peraturan dan perundang-undangan yang berlaku.
                                </Typography>
                                <br/>
                                <Typography variant="body1">
                                    Penanggungjawab
                                </Typography>
                                <Typography variant="body1" style={{fontWeight:'bold'}}>
                                    Kepala Sekolah {this.props.sekolah.nama}
                                </Typography>

                                <br/>
                                <br/>
                                <br/>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                        checked={this.state.checkboxSetujuValue}
                                        onChange={this.setValueCheckbox}
                                        name="checkboxSetuju"
                                        key="checkboxSetuju"
                                        color="primary"
                                        disabled={this.state.checkDisabled}
                                        />
                                    }
                                    label="Saya setuju dengan pakta integritas sekolah di atas"
                                    className="checkboxSetuju"
                                />
                                <br/>
                                <Button 
                                    variant="raised" 
                                    color="primary" 
                                    disabled={this.state.buttonDisabled}
                                    onClick={this.simpanFaktaIntegritas}
                                >
                                    {this.state.teksButton}
                                </Button>
                                &nbsp;
                                <Button 
                                    variant="raised" 
                                    // color="secondary"
                                    style={{background:(this.state.buttonDisabledBatal ? '#cccccc' : 'red'), color:'white'}} 
                                    disabled={this.state.buttonDisabledBatal} 
                                    onClick={this.simpanFaktaIntegritasBatal}
                                >
                                    Batalkan Pakta Integritas
                                </Button>

                                <br/>
                                <br/>
                                <Divider/>
                                <br/>
                                {/* <Paper className="p-16 bg-teal text-white mb-8">
                                    Pakta integritas pengawas telah disimpan pada tanggal ... 
                                </Paper> */}
                                {/* <br/> */}
                                {this.state.kunci_pakta === true &&
                                <Paper className="p-16 bg-green text-white">
                                    <Typography variant="subheading" className="text-white font-bold">Terima kasih!</Typography>
                                    <b>Pakta integritas sekolah</b> telah dikonfirmasi pada tanggal {this.props.timeline[2].tanggal} 
                                </Paper>
                                }
                            </Paper>

                        </div>
                    </FuseAnimate>
                }
            />
        )
    }

}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getSekolah: Actions.getSekolah,
        setKunciKonfirmasiInstrumen: Actions.setKunciKonfirmasiInstrumen,
        getKonfirmasiSelesai: Actions.getKonfirmasiSelesai,
        getKemajuanTotal: Actions.getKemajuanTotal,
        getPeringkatPengisian: Actions.getPeringkatPengisian,
        setLoading: Actions.setLoading,
        setJudul: Actions.setJudul,
        getProsesRapor: Actions.getProsesRapor,
        getRaporMutuRadar: Actions.getRaporMutuRadar,
        setDataTahun: Actions.setDataTahun,
        setDataWilayah: Actions.setDataWilayah,
        catatTimeline: Actions.catatTimeline,
        catatTimelineBatal: Actions.catatTimelineBatal,
        getTimeline: Actions.getTimeline,
        setLoadingBesar: Actions.setLoadingBesar,
        setNotifikasi: Actions.setNotifikasi,
        getNotifikasi: Actions.getNotifikasi
    }, dispatch);
}

function mapStateToProps({ Sekolah, Instrumen, RaporMutu }) {

    return {
        sekolah: Sekolah.sekolah,
        konfirmasi_instrumen_id: Instrumen.konfirmasi_instrumen_id,
        konfirmasi_instrumen: Instrumen.konfirmasi_instrumen,
        kemajuan_total: Instrumen.kemajuan_total,
        peringkat_pengisian: Instrumen.peringkat_pengisian,
        proses_rapor_mutu: RaporMutu.proses_rapor_mutu,
        rapor_mutu_radar: RaporMutu.rapor_mutu_radar,
        data_tahun: RaporMutu.data_tahun,
        data_wilayah: RaporMutu.data_wilayah,
        hasil_catat_timeline: Instrumen.hasil_catat_timeline,
        timeline: RaporMutu.timeline
    }
}

// export default withStyles(styles, {withTheme: true})(Beranda);
export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(PaktaIntegritas)));



// WEBPACK FOOTER //
// ./src/main/content/RaporMutu/PaktaIntegritas.js